(function(){

    angular.module('tmx-app').controller('pjpCtrl', ['resolvedData', '$scope', '$state','$mdSidenav',
        'PjpService','TmxDialogService','tmxUtility','menu', 
    
        function PjpCtrl(resolvedData, $scope, $state, $mdSidenav, PjpService,TmxDialogService,tmxUtility,menu) {
            var pjpVM = this;
            var exists;
            var copy;
            pjpVM.EntityName = "PJP";
            exists = tmxUtility.exists;
            copy = tmxUtility.copy;
///////////////////////// CHECKING PRIVILEGES OF THIS ENTITY///////////////////////////////////////////////////////
            pjpVM.menu = menu;
            pjpVM.Privileges = [];
            pjpVM.ViewPrivilege = false;
            pjpVM.EditPrivilege = false;
            pjpVM.DeletePrivilege = false;
            pjpVM.AddPrivilege = false;
            pjpVM.checkPermission = tmxUtility.checkPermission;                
            pjpVM.formatPjpDate = tmxUtility.formatDateForCompany;                            
            pjpVM.editPermission= pjpVM.checkPermission('Private.Journeyplans.Pjp','Edit');                                  

   //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            pjpVM.query = "Pjp";
            pjpVM.gridData = new kendo.data.ObservableArray([]);
            pjpVM.date = new Date().toJSON();
            pjpVM.cols = PjpService.gridColumn;
            pjpVM.nav = "SearchSideNav";
            pjpVM.mdnav = "SearchSideNav";
            pjpVM.schema = PjpService.schema;
            pjpVM.cloneColumn = PjpService.gridColumn;
            pjpVM.users = resolvedData.Users;
            pjpVM.PjpService = PjpService;
            pjpVM.Locations = resolvedData.Locations.data;


    //**********functions****************

            pjpVM.success = function (promise) {
                if (promise.read == true) {
            // pjpVM.container.pjpGrid.dataSource.transport.read(promise);
                    for (var j = pjpVM.container.pjpGrid.columns.length - 1; j >= 0; j--) {


                        if (angular.isDefined(pjpVM.o.data.filter) && pjpVM.o.data.filter != null) {
                            if (angular.isDefined(pjpVM.o.data.filter.filters) && pjpVM.o.data.filter.filters.length > 0) {
                                for (var i = pjpVM.o.data.filter.filters.length - 1; i >= 0; i--) {
                                    if (pjpVM.o.data.filter.filters[i].field == pjpVM.container.pjpGrid.columns[j].field) {
                                        pjpVM.container.pjpGrid.columns[j].headerTemplate = "<span>" + pjpVM.container.pjpGrid.columns[j].title + "<md-icon >file_download</md-icon></span>";
                                        pjpVM.container.pjpGrid.columns[j].title = "changed";
                                    }
                                }
                            }
                        }
                    }
                }
                else {
            // pjpVM.container.pjpGrid.dataSource.read();
                }
        // pjpVM.toggleSearch(pjpVM.nav);
            };

            pjpVM.onChildState = function () {
                if ($state.current.name.indexOf(".add") > 0 || $state.current.name.indexOf(".edit") > 0) return true;
            }

            pjpVM.isOpen = function (navID) {
                return $mdSidenav(navID).isOpen();
            };

            pjpVM.new = function () {
                $state.go($state.current.name + ".add");
            };

            pjpVM.newGeofence = function () {
                $state.go("private.masterdata.geofence.add");
            };

            pjpVM.clickEdit = function (item) {
                $state.data.info = false;
                $state.go($state.current.name + ".edit", {"Id": item.PJPMasterId});
            }

    // $state.data.info = false;

            pjpVM.clickView = function (item) {
                $state.data.info = true;
                $state.go($state.current.name + ".edit", {"Id": item.PjpMasterId});
            }

            pjpVM.clickActive = function (item) {
        //   var confirm = $mdDialog.confirm()
        //     .title('Activate Pjp '+item.PjpName+" ?")
        //     .textContent('Are you sure you want to activate this Pjp?')
        //     .ariaLabel('Lucky day')
        //     .clickOutsideToClose(true)
        //     // .targetEvent(ev)
        //     .ok('Yes')
        //     .cancel('Cancel');
        //
        //$mdDialog.show(confirm).then(function() {
        //   item.$activate(item.PjpMasterId).then(function(result)
        //   {
        //     pjpVM.container.pjpGrid.dataSource.read();
        //   });
        //}, function() {
        //
        //});
                var diagConfig = {
                    action: "Activate",
                    entity: "Pjp",
                    entityname: item.PjpName,
                    details: [
                        {value: item.PjpMasterId, label: "Pjp Master Id "},
                        {value: item.PjpName, label: "Pjp Name"},
                        {value: item.PjpDescription, label: "Pjp Description"}

                    ],
                    options: [
                        {label: "Activate", value: true, class: "md-warn"},
                        {label: "Cancel", value: false, class: "md-primary"}
                    ]
                };

                function callback(ok) {
                    if (ok) {
                        pjpVM.Activate(item);
                    }
                }

                var pjpActivateDialog = new TmxDialogService.confirmDialog(diagConfig, callback);

                pjpActivateDialog.show();
            }
            pjpVM.Activate = function (item) {
                item.$activate(item.PjpMasterId).then(function () {
                    pjpVM.container.pjpGrid.dataSource.read();
                });
            };
            pjpVM.clickInactive = function (item) {
                var diagConfig = {
                    action: "Deactivate",
                    entity: "Pjp",
                    entityname: item.PjpName,
                    details: [
                        {value: item.PjpMasterId, label: "Pjp Master Id "},
                        {value: item.PjpName, label: "Pjp Name"},
                        {value: item.PjpDescription, label: "Pjp Description"}

                    ],
                    options: [
                        {label: "Deactivate", value: true, class: "md-warn"},
                        {label: "Cancel", value: false, class: "md-primary"}
                    ]
                };

                function callback(ok) {
                    if (ok) {
                        pjpVM.Deactivate(item);
                    }
                }

                var pjpDeactivateDialog = new TmxDialogService.confirmDialog(diagConfig, callback);

                pjpDeactivateDialog.show();


            };
            pjpVM.Deactivate = function(item) {
                item.$deactivate(item.PjpMasterId).then(function() {
                    pjpVM.container.pjpGrid.dataSource.read();
                });
            };

  
   //**********kendo row template functions************


            pjpVM.clickDelete = function () {            
                //deleteConfirm(item);
            }

            pjpVM.isStatusActive=function(dataitem) {
         
                if (dataitem == "Active")
                    return true;
                else
                    return false;
            };
            pjpVM.isEditable=function(dataitem){
                if((dataitem.Status=="Active" || dataitem.Status=="Pending") && pjpVM.editPermission){
                    return true;
                }
                return false;
            }

            pjpVM.isStatusPending=function(dataitem) {
         
                if (dataitem == "Pending")
                    return true;
                else
                    return false;
            };

            pjpVM.formatPjpName=function(dataitem) {

                return  tmxUtility.sliceText(dataitem,20);
            }
            pjpVM.formatPjpCount=function(dataitem) {

                return dataitem.CustomerPJPCount;
            }
            pjpVM.formatPjpUser=function(dataitem) {

                return dataitem.PJPClusterUser;
            }
            pjpVM.getDescription=function(dataitem) {
                if(dataitem.PJPDescription!=null && angular.isDefined(dataitem.PJPDescription)) {
                    return dataitem.PJPDescription;
                }
                return "N/A";
            }

            pjpVM.status=function(dataitem){

                return dataitem.Status;
            }

            pjpVM.getLocation=function(dataitem){
  
                if(dataitem!=null && angular.isDefined(dataitem)) {
                    for (var i = pjpVM.Locations.length - 1; i >= 0; i--) {
                        if(pjpVM.Locations[i].HiddenValue==dataitem)
                            return pjpVM.Locations[i].VisibleValue;
                    }
                }

                return "N/A";
            }
            pjpVM.isFiltered=function(fieldName){
                var filtered = false;
                if(fieldName=="Status"){
                    fieldName="EffectiveEndDate";
                }
                if(angular.isDefined(pjpVM.filters)) {
                    pjpVM.filters.filters.forEach(function(filter){
                        if(filter.field==fieldName)
                            filtered = true;
                    });
                }
                return filtered;
            }         

//***********************************************


//*******************KENDO*********************//  
            pjpVM.gridColumns = PjpService.columns;

            pjpVM.defaultFilters = [
                {
                    "field": "Status",
                    "operator": "neq",
                    "value": 'Inactive'
                }
            ];

            pjpVM.mainGridOptions = {
                dataSource: {
            
                    transport: {
                        read: function(o){
                            if(angular.isDefined(pjpVM.searchClear) && pjpVM.searchClear==false){
                                if(exists(pjpVM.o)){
                                    copy(pjpVM.o.data,["filter"],o.data);
                                }
                            }
                            pjpVM.searchClear = false;
                            if(pjpVM.onChildState()){return;}
                            if(!o.fromSideNav) {
                                if($state.searchClear){
                                    pjpVM.searchClear = true;
                                    $state.searchClear=undefined;
                            //return;
                                }
                        //if(exists(companyVM.o)){
                        //copy(companyVM.o.data,["filter"],o.data);
                        //}
                            }
                            else{
                                o.data.firstPage = true;
                            }
                            pjpVM.o = angular.copy(o);
                            pjpVM.filters = pjpVM.o.data.filter;
                            PjpService.getByParams(o,true).then(function(response){
                                parseResppnse(response.data);
                                pjpVM.excelData=response;
                                o.success(response)
                            });
                        },

                        dataType: "json"
                    },
                    filter: pjpVM.defaultFilters,
                    schema: {
                        data: "data",
                        total: "Total"
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
            
            // sort:  [{field: "EffectiveEndDate", dir: "desc"}],
                },
                excelExport: function(e) {                              
                    var sheet = e.workbook.sheets[0];
                    var data = pjpVM.excelData.data;
                    var gridColumns = pjpVM.container.pjpGrid.columns;  
                    data=setLookupValue(data);
                    var columns = tmxUtility.columnsMapping(gridColumns);                    
                    var rows=tmxUtility.dataMapping(data,columns);
                    sheet.rows = rows;                                                                                     
                },         
                pageable: {
                    refresh: true,
                    pageSizes: true,
                    pageSize: 10,
                    buttonCount: 5
                },
                pdf: {
                    allPages: true,
                    fileName: "Pjps.pdf"
                },
                excel: {
                    allPages: true,
                    fileName: "Pjps.xlsx"
                },
          // filterable:true,
        // sortable: true,
                sortable:true,
                scrollable: false,
        // groupable: true,        
                rowTemplate: "<tr data-uid='#= uid #'><td><md-button class='tmx-primary-text-grid' ng-disabled='!dataItem.editable' ng-click='PjpCtrl.clickEdit(dataItem)' ng-bind='dataItem.PJPName'></md-button><div class='margin-bottom-2'> <span class='chip' ng-style={{dataItem.StatusBKColor}}> {{dataItem.Status}}</span> <span class='subtitle'>{{dataItem.PJPClusterUser | defaultValue}}</span> </div></td><td class='grid-col'> {{dataItem.LocationName}} </td><td class='grid-col'> {{dataItem.FormattedEffectiveStartDate}}   </td><td class='grid-col' class='menu-item-col'><md-menu flex='none' class='menu-list-item' md-offset='-20 60'><md-button class='menu-list-item-grid'  ng-click='$mdOpenMenu()' ><md-icon class='menu-list-item material-icons'>more_vert</md-icon></md-button><md-menu-content width='2' ><md-menu-item><md-button aria-label='del' class='tmxMin' ng-disabled='!PjpCtrl.ViewPrivilege' ng-click='PjpCtrl.clickView(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>info</md-icon>Info</md-button></md-menu-item><md-menu-item ng-if='dataItem.statusActive && !dataItem.statusPending'><md-button  aria-label='del' class='tmxMin' ng-disabled='!PjpCtrl.DeletePrivilege' ng-click='PjpCtrl.clickInactive(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>remove_circle</md-icon>Deactivate Pjp</md-button></md-menu-item><md-menu-item ng-if='dataItem.statusActive && !dataItem.statusPending'><md-button  aria-label='del' class='tmxMin' ng-click='PjpCtrl.clickActive(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>check_circle</md-icon>Activate Pjp</md-button></md-menu-item></md-menu-content></md-menu></td></tr>",
                columns: PjpService.columns
            };

            function parseResppnse(data){
                data.forEach(function(dataItem){                                                                            
                    dataItem.editable= pjpVM.isEditable(dataItem);    
                    dataItem.PJPName=pjpVM.formatPjpName(dataItem.PJPName);   
                    dataItem.StatusBKColor=tmxUtility.SetStatusBackgroundColor(dataItem.Status);   
                    dataItem.LocationName=pjpVM.getLocation(dataItem.LocationId);     
                    dataItem.FormattedEffectiveStartDate=pjpVM.formatPjpDate(dataItem.EffectiveStartDate)    
                    dataItem.statusActive=pjpVM.isStatusActive(dataItem.Status);
                    dataItem.statusPending=pjpVM.isStatusPending(dataItem.Status);
                });                                
            }

//*****************************************
            pjpVM.container = {};
            $state.data={
                grid: pjpVM.container,
                info: false

            };


//************for filtering/search************
            pjpVM.searchSideNavActive=false;
    
            pjpVM.toggleSearch=function(){
                if(pjpVM.searchSideNavActive) {
                    pjpVM.searchData = {};
                    pjpVM.searchSideNavActive=false;
                }
                else
                    pjpVM.searchSideNavActive=true;
                pjpVM.toggle('SearchSideNav');
            }
            pjpVM.exportSideNavActive=false;

            pjpVM.toggleExport=function(){
                if(pjpVM.exportSideNavActive)
                    pjpVM.exportSideNavActive=false;
                else
                    pjpVM.exportSideNavActive=true;
                pjpVM.toggle('ExportSideNav');
            }

            pjpVM.toggle = function(navID) {
                $mdSidenav(navID)
                    .toggle()
                    .then(function() {
                    });
            };

            pjpVM.filt = {};
    

            pjpVM.search = function(navID) {
      
                let calls=[];
  

                for (var key in pjpVM.searchData) {
                    if (pjpVM.searchData.hasOwnProperty(key)) {
                        calls.push({
                            field: key,
                            operator: "contains",
                            value: pjpVM.searchData[key]
                        });
                    }
                }

                pjpVM.filt = {
                    filters: calls,
                    logic: "and"
                };
                pjpVM.o.data.filter = pjpVM.filt;
                pjpVM.container.pjpGrid.dataSource.transport.read(pjpVM.o);

                pjpVM.searchData = {};
                pjpVM.toggle(navID);
            };

            pjpVM.clear = function(navID) {
                pjpVM.searchData = {};
                pjpVM.toggle(navID);
            };

            function setLookupValue(data){
                for (var i = 0; i < data.length; i++){                    
                    if(exists(data[i].LocationId)){
                        var location=PjpService.locations.filter(x=>x.HiddenValue==data[i].LocationId)[0];
                        data[i].LocationId=location.VisibleValue;
                    }
                }
                return data;
            }

        }]);
})();